<template>
    <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">Trade payables and accruals</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">736,110</td>
                            <td class="end font">647,754</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Due to roaming partners</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"> 9,884</td>
                            <td class="end font">9,107</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Due to other operators (interconnect)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">20,705</td>
                            <td class="end font">10,217</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Dues to regulatory authorities (refer below)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"> 97,898</td>
                            <td class="end font">76,758</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Taxes payable</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">62,136</td>
                            <td class="end font">51,632</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Dividend payable</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">24,128</td>
                            <td class="end font">15,760</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Provisions</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">2,763</td>
                            <td class="end font">2,756</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Directors’ remuneration</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">435</td>
                            <td class="end font">510</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Other payables</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"> 36,704</td>
                            <td class="end font">43,018</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">990,763</td>
                            <td class="end font white font-weight-bold">857,512</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">ذمم تجارية دائنة ومستحقات</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">736,110</td>
                            <td class="end font">647,754</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">المستحق لمشغلي خدمات التجوال</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"> 9,884</td>
                            <td class="end font">9,107</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">مستحق للمشغلين الآخرين (الربط البيني)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">20,705</td>
                            <td class="end font">10,217</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">مستحق لهيئات رقابية (انظر أدناه)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"> 97,898</td>
                            <td class="end font">76,758</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">ضرائب مستحقة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">62,136</td>
                            <td class="end font">51,632</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">توزيعات مستحقة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">24,128</td>
                            <td class="end font">15,760</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">مخصصات</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">2,763</td>
                            <td class="end font">2,756</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">مكافأة أعضاء مجلس الإدارة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">435</td>
                            <td class="end font">510</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">ذمم دائنة أخرى</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray"> 36,704</td>
                            <td class="end font">43,018</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">990,763</td>
                            <td class="end font white font-weight-bold">857,512</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>